import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/home/pages/home.page').then((m) => m.HomePageComponent),
  },

  {
    path: 'perfil',
    loadComponent: () =>
      import('./features/perfil/perfil.shell').then((m) => m.PerfilShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'contacto' },
      {
        path: 'contacto',
        loadComponent: () =>
          import('./features/perfil/pages/contacto.page').then((m) => m.ContactoPageComponent),
      },
      {
        path: 'empleadores',
        loadComponent: () =>
          import('./features/perfil/pages/empleadores.page').then((m) => m.EmpleadoresPageComponent),
      },
      {
        path: 'cuenta',
        loadComponent: () =>
          import('./features/perfil/pages/cuenta.page').then((m) => m.CuentaPageComponent),
      },
      {
        path: 'autorizaciones',
        loadComponent: () =>
          import('./features/perfil/pages/autorizaciones.page').then(
            (m) => m.AutorizacionesPageComponent,
          ),
      },
    ],
  },

  {
    path: 'empresa',
    children: [
      {
        path: 'trabajadores',
        loadComponent: () =>
          import('./features/empresa/pages/trabajadores.page').then(
            (m) => m.TrabajadoresPageComponent,
          ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'trabajadores' },
    ],
  },

  { path: '**', redirectTo: '' },
];
